import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'
import AssessmentApp from './components/AssessmentApp'
import ProctoringTest from './components/ProctoringTest'
import AdminLogin from './components/admin/AdminLogin'
import AdminLayout from './components/admin/AdminLayout'
import AssessmentList from './components/admin/AssessmentList'
import AssessmentForm from './components/admin/AssessmentForm'

export default function AppRouter() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminLayout />}>
          <Route index element={<AssessmentList />} />
          <Route path="assessments/new" element={<AssessmentForm />} />
          <Route path="assessments/:slug/edit" element={<AssessmentForm />} />
        </Route>
        <Route path="/proctoring-test" element={<ProctoringTest />} />
        <Route path="/:slug" element={<AssessmentApp />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  )
}
